export const getIsOperatingUnitTransport = (
  fromOrganization,
  toOrganization,
  organizations
) => {
  const from =
    fromOrganization?.value &&
    organizations.find(o => o.id === fromOrganization.value);
  const to =
    toOrganization?.value &&
    organizations.find(o => o.id === toOrganization.value);

  return from?.subType === 'UNIT_OPERATING' || to?.subType === 'UNIT_OPERATING';
};